export default {
    jobs: [],
    jobsLoading: false,
    jobPrintColors: [],
    orderComponents: [],
    productTypeConfigurations: [],
    orderComponentsLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        search: null,
        status_ids: true,
    }
}
